module.exports = __webpack_public_path__ + "static/media/2pic.3ca5a007.jpg";